"use client"
import { cn } from "@/lib/utils";
import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandTiktok,
  IconBrandYoutube,
} from "@tabler/icons-react";
import Link from "next/link";

export default function Footer() {
  const SOCIAL_MEDIA = [
    {
      title: "Facebook",
      href: "https://www.facebook.com/patancollege",
      icon: <IconBrandFacebook />,
    },
    {
      title: "Instagram",
      href: "https://www.instagram.com/pcpscollege/",
      icon: <IconBrandInstagram />,
    },
    {
      title: "LinkedIn",
      href: "https://www.linkedin.com/school/pcpscollege/mycompany/",
      icon: <IconBrandLinkedin />,
    },
    {
      title: "Tiktok",
      href: "https://www.tiktok.com/@pcps_college",
      icon: <IconBrandTiktok />,
    },
    {
      title: "YouTube",
      href: "https://www.youtube.com/@pcpscollege",
      icon: <IconBrandYoutube />,
    },
  ];

  const QUICK_LINKS = [
    {
      title: "About Us",
      href: "/about-us",
    },
    {
      title: "Students",
      href: "/students",
    },
    {
      title: "Breo",
      href: "https://breo.beds.ac.uk/",
    },
    {
      title: "Evision",
      href: "https://evision.beds.ac.uk/",
    },
  ];

  const POLICIES = [
    {
      title: "Policy on Consensual Relationships and Prevention of Sexual Misconduct",
      href: "/policies/Policy on Consensual Relationships and Prevention of Sexual Misconduct.pdf",
    },
    {
      title: "Policy on Prevention of Sexual Harassment at Workplace",
      href: "/policies/Policy on Prevention of Sexual Harassment at Workplace.pdf",
    },
  ];

  const CONTACTS = [
    {
      label: "Phone",
      value: "015181198",
      href: "tel:+977015181198",
    },
    {
      label: "Address",
      value: (
        <>
          <span className="block">Pcps College</span>
          <span className="block">Kandevatasthan</span>
          <span className="block">Lalitpur, Nepal</span>
        </>
      ),
      href: "https://maps.app.goo.gl/vF9zxmb8cZT41HTS6",
    },
    {
      label: "Events",
      value: (
        <>
          <span className="block">Rishika Dahal</span>
          <span className="block">College Events Head</span>
          <span className="block">9801102247</span>
        </>
      ),
      href: "tel:+9779801102247",
    },
    {
      label: "Admission",
      value: (
        <>
          <span className="block">Pramila Ghimire</span>
          <span className="block">Admission Manager</span>
          <span className="block">9801102235</span>
        </>
      ),
      href: "tel:+9779801102235",
    },
  ];

  return (
    <footer
      className="xl:px-[3.305785124%] md:pb-[2rem] md:px-[6.5104166667%] w-full table 
      clear-both p-[3.0625rem_1.25rem_1.875rem] bg-black text-white relative
      before:w-full before:max-w-[90rem] before:block before:relative before:top-[-3.0625rem]
      before:m-auto border-b-[1px] border-[#EDEDED] border-t
      "
    >
      <div
        className={`
          xl:p-[0_3.5398230088%_2.6875rem] md:w-full border-b-[1px]
          border-b-secondary-red md:pb-[2.875rem] m-auto w-[87.5%] max-w-[90rem]
          clear-both grid grid-cols-1 md:grid-cols-4 gap-y-10 md:gap-x-8
        `}
      >
        {/* 1. The Mission */}
        <section
          className={`
            md:col-span-1
          `}
        >
          <h2
            className={`md:mb-[1.25rem] md:text-[0.6875rem] md:leading-[0.625rem]
              mt-0 font-bold text-[0.75rem] leading-[0.75rem] tracking-[0.09375rem]
              uppercase
              `}
          >
            The Mission
          </h2>
          <p
            className={`
              xl:text-[1.125rem] xl:leading-[1.875rem] md:m-0 futura-heavy text-[0.875rem]
              leading-[1.4375rem]
              `}
          >
            Transforming students with potential to amazing professionals
          </p>
        </section>

        {/* 2. Policies */}
        <section
          className={`
            md:col-span-1
          `}
        >
          <h2
            className={`md:mb-[1.3125rem] md:text-[0.6875rem] md:leading-[0.625rem]
              mb-[1.25rem] mt-0 font-bold text-[0.75rem] leading-[0.75rem] tracking-[0.09375rem]
              uppercase
                `}
          >
            Policies
          </h2>

          <nav className={`md:mt-0 table mt-[-0.75rem] `}>
            <ul className={`[list-style-type:none;] pl-0 m-0`}>
              {POLICIES.map((policy) => (
                <li key={policy.title} className="mb-2">
                  <Link
                    href={policy.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`
                      xl:text-[0.75rem] xl:leading-[1.375rem]
                      md:leading-[1.5rem]
                      transition-[color_0.35s_ease-out]
                      text-[0.875rem]
                      leading-[2rem] float-left clear-both [text-decoration:none;]
                      hover:text-primary-red hover:underline hover:text-shadow-secondary-red
                      hover:transition-[color_0.15s_ease]
                    `}
                  >
                    {policy.title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </section>

        {/* 3. Quick Links */}
        <section
          className={`
            md:col-span-1
          `}
        >
          <h2
            className={`md:mb-[1.3125rem] md:text-[0.6875rem] md:leading-[0.625rem]
              mb-[1.25rem] mt-0 font-bold text-[0.75rem] leading-[0.75rem] tracking-[0.09375rem]
              uppercase
                `}
          >
            Quick Links
          </h2>
          <nav className={`md:mt-0 table mt-[-0.75rem] `}>
            <ul className={`[list-style-type:none;] pl-0 m-0`}>
              {QUICK_LINKS.map((link) => (
                <li key={link.title} className="mb-2">
                  <Link
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`
                      xl:text-[0.75rem] xl:leading-[1.375rem] md:leading-[1.5rem]
                      transition-[color_0.35s_ease-out] text-[0.875rem]
                      leading-[2rem] float-left clear-both [text-decoration:none;]
                      hover:text-primary-red hover:underline hover:[text-decoration-color:#A31F34;]
                      hover:transition-[color_0.15s_ease]
                    `}
                  >
                    {link.title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </section>

        {/* 4. Find Us / Contact */}
        <section
          className={`
            md:col-span-1
          `}
        >
          <h2
            className={`md:mb-[1.3125rem] md:text-[0.6875rem] md:leading-[0.625rem]
              mb-[1.25rem] mt-0 font-bold text-[0.75rem] leading-[0.75rem] tracking-[0.09375rem]
              uppercase
                `}
          >
            Find us
          </h2>
          <span
            className={`text-[0.75rem] leading-[1.375rem] m-[0_0_1.0625rem] block`}
          >
            <Link
              href={CONTACTS[1].href}
              target="_blank"
              rel="noopener noreferrer"
              className={`
                transition-[color_0.35s_ease-out] [text-decoration:none]
                hover:text-primary-red hover:underline hover:[text-decoration-color:#A31F34;] hover:transition-[color_0.15s_ease]
              `}
            >
              <strong className={`clear-both block futura-heavy`}>
                Pcps College
              </strong>
              <span className={`clear-both block`}>Kandevatasthan</span>
              <span className="clear-both block">Lalitpur, Nepal</span>
            </Link>
            <Link
              href={CONTACTS[0].href}
              className={`futura-medium text-[0.75rem] leading-[1.375rem] m-0 transition-[color_0.35s_ease-out] block [text-decoration:none]
                hover:text-primary-red hover:underline hover:[text-decoration-color:#A31F34;]
                hover:transition-[color_0.15s_ease]
                  `}
            >
              {CONTACTS[0].value}
            </Link>
          </span>

          <span
            className={`text-[0.75rem] leading-[1.375rem] m-[0_0_1.0625rem] block border-t border-[#333333] pt-[0.625rem]`}
          >
            <small
              className={`block text-[0.625rem] leading-[1rem] tracking-[0.03125rem] uppercase text-[#888888] mb-[0.375rem]`}
            >
              For Events
            </small>
            <Link
              href={CONTACTS[2].href}
              className={`futura-medium text-[0.75rem] leading-[1.375rem] m-0 transition-[color_0.35s_ease-out] block [text-decoration:none]
                hover:text-primary-red hover:underline hover:[text-decoration-color:#A31F34;]
                hover:transition-[color_0.15s_ease]
                  `}
            >
              {CONTACTS[2].value}
            </Link>
          </span>

          <span
            className={`text-[0.75rem] leading-[1.375rem] m-0 block border-t border-[#333333] pt-[0.625rem]`}
          >
            <small
              className={`block text-[0.625rem] leading-[1rem] tracking-[0.03125rem] uppercase text-[#888888] mb-[0.375rem]`}
            >
              For Admission
            </small>
            <Link
              href={CONTACTS[3].href}
              className={`futura-medium text-[0.75rem] leading-[1.375rem] m-0 transition-[color_0.35s_ease-out] block [text-decoration:none]
                hover:text-primary-red hover:underline hover:[text-decoration-color:#A31F34;]
                hover:transition-[color_0.15s_ease]
                  `}
            >
              {CONTACTS[3].value}
            </Link>
          </span>
        </section>

        {/* 5. Social Media */}
        <section
          className={`
            md:col-span-1
          `}
        >
          <h2
            className={`md:mb-[1.3125rem] md:text-[0.6875rem] md:leading-[0.625rem]
              mb-[1.25rem] mt-0 font-bold text-[0.75rem] leading-[0.75rem] tracking-[0.09375rem]
              uppercase
                `}
          >
            Connect
          </h2>
          <nav className={`flex space-x-4`}>
            {SOCIAL_MEDIA.map((media) => (
              <Link
                key={media.href}
                href={media.href}
                target="_blank"
                rel="noopener noreferrer"
                title={media.title}
                className={cn(
                  `float-left
                  h-[1.875rem]
                  min-w-[1.0625rem]
                  [text-decoration:none;]
                  transition-[color_0.35s_ease-out;]
                  `
                )}
              >
                {media.icon}
              </Link>
            ))}
          </nav>
        </section>
      </div>

      <div
        className={`xl:p-[0_3.5398230088%] md:w-full m-auto w-[87.5%] max-w-[90rem] table clear-both`}
      >
        <small
          className={`xl:mt-[1.5rem] md:clear-both md:mt-[1.875rem] futura-medium
          uppercase text-[0.625rem] leading-[0.625rem] float-left w-full clear-both m-0 text-center
              `}
        >
          ©{new Date().getFullYear()} PCPS College
        </small>
        <small className={`xl:mt-[1.5rem] md:w-auto md:clear-both md:mt-[1.875rem] futura-medium
          uppercase text-[0.625rem] leading-[0.625rem] float-left w-full clear-both m-0
              `}>Disclaimer: * denotes group statistics</small>
      </div>
    </footer>
  );
}